module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-mov-2.b5023a65.png";